import { Link } from "react-router-dom";
import type { TenantBranding } from "../types";

// E4 — access denied. Rendered when the embed-URL mint returns 403.
// No Metabase chrome leaks — pure SPA screen.
export function VentureDenied({ branding }: { branding: TenantBranding }) {
  return (
    <div className="venture">
      <div className="venture-body" style={{ paddingTop: 64 }}>
        <div className="denied-card">
          <div className="denied-eyebrow">{branding.application_name}</div>
          <h1>You don't have access to this page.</h1>
          <p>
            Your admin can grant you access from the operator console.
            If you think this is a mistake, ask them to check your access matrix.
          </p>
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
